/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   constants.ts
 */

import type { SavedCustomMessage } from '@zcode/state-type'

export const ROOT_STATE_KEY = 'savedCustomMessage' as const

export const SAVED_CUSTOM_MESSAGE_INITIAL_STATE: SavedCustomMessage = {
  customMessageChecked: false,
  customMessageHasBeenChecked: false,
}

export const SAVED_CUSTOM_MESSAGE_LOCALSTORAGE_KEY = 'SAVED_CUSTOM_MESSAGE' as const
export const SAVED_CUSTOM_MESSAGE_TOGGLE_TEXT = 'Save this as my default message' as const

export const SAVED_CUSTOM_MESSAGE_TRAKTOR_CATEGORY = '[Saved message]' as const

export const SAVED_CUSTOM_MESSAGE_TRAKTOR_ACTIONS = {
  TOGGLE_ON: '[Saved message] Click toggle on',
  TOGGLE_OFF: '[Saved message] Click toggle off',
  EDIT_MESSAGE: '[Saved message] Edit message',
  SAVE_MESSAGE: '[Saved message] Save message',
} as const
